/** Zentrale Overlay-Ebenen. Child-Overlays müssen immer über ihrem Parent liegen. */
export const APP_OVERLAY = {
  sheet: 1650,
  dialog: 1750,
  fullscreen: 1800,
  systemStatus: 2600,
  statusIsland: 2700,
  systemStatusChild: 2800,
} as const;
